//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetchAll, _STATUS, _STATUS_COLOR } from '@/apis/memberAccountTransfer'
import moment from 'moment';

export default {
    data() {
        return {
            config: {
                //運動類型
                status: [],
            },
            searchQuery: {
                status: '',
                sDate: '',
                eDate: '',
                phone: '',
            },
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns = [
            { title: 'ID', dataIndex: 'id', key: 'id', width: 120, },
            { title: '轉讓人', dataIndex: 'fromName', key: 'fromName', width: 330, },
            { title: '轉讓人電話', dataIndex: 'fromPhone', key: 'fromPhone', width: 330, },
            { title: '轉讓點數', key: 'amount', width: 150, scopedSlots: { customRender: 'amountSlot' }, },
            { title: '狀態', key: 'status', scopedSlots: { customRender: 'statusSlot' }, width: 160, },

            { title: '接收人', dataIndex: 'toName', key: 'toName', width: 330, },
            { title: '接收人電話', dataIndex: 'toPhone', key: 'toPhone', width: 330, },

            { title: '創建時間', dataIndex: 'createdTime', key: 'createdTime', width: 180, },
            { title: '轉讓成功時間', dataIndex: 'paymentTime', key: 'paymentTime', width: 180, },
            // { title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, }
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        moment,
        onChangeDate(value) {
            this.searchQuery.sDate = value[0].format('YYYY-MM-DD HH:mm')
            this.searchQuery.eDate = value[1].format('YYYY-MM-DD HH:mm')
        },
        async onPageConfig() {
            try {
                let _status = [];
                Object.keys(_STATUS).forEach(value => {
                    _status.push({
                        id: value,
                        name: _STATUS[value]
                    })
                })
                this.config.status = _status;

            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await fetchAll({
                    ...this.searchQuery,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                this.records = this.parseRecords(res.data.records);
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        parseRecords(records) {

            records.forEach((record) => {
                record.status_text = this._getStatusText(record.status);
                record.status_text_color = this._getStatusTextColor(record.status);
            })

            return records
        },
        //獲取運動類型名稱
        _getStatusText(code) {
            return _STATUS[code] !== undefined ? _STATUS[code] : '';
        },
        _getStatusTextColor(code) {
            return _STATUS_COLOR[code] !== undefined ? _STATUS_COLOR[code] : '';
        },

        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        },
        //狀態更新
        async handleOnEditState(item, status) {
            //edit state
            try {
                const res = await venues_changeState(item.id, status);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        //刪除行
        async handleOnDelete(item) {
            try {
                const res = await destroy(item.id);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                console.log('delete error', error);
            }
        },
        handleToDetails(id) {
            this.$router.push(`/gymnasium/${id}`);
        },
        handleToForm(id) {
            if (id > 0) {
                this.$router.push(`/activity/edit/${id}`);
            } else {
                this.$router.push('/activity/add');
            }

        }
    }
}
